
export function onlyInteger() {

    return {
        require: 'ngModel',
        restrict: 'A',
        link: (scope, element, attr, ngModelCtrl) => {

            function cleaning() {

                let cleaned = '';

                if (ngModelCtrl.$viewValue) {

                    cleaned = ngModelCtrl.$viewValue.replace(/[^\d]/ig, '').trim();
    
                    ngModelCtrl.$setViewValue(cleaned);
    
                    ngModelCtrl.$render();
                }

                return cleaned;
            }

            ngModelCtrl.$parsers.push(cleaning);
        }
    };
}



// WEBPACK FOOTER //
// ./src/ui/directives/only-integer.directive.js